import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getDialogConfig() {
    return {
        custom: {
            [PALETTE_IDS.BET_SHARING_DIALOG]: {
                ShareBetContent: {
                    container: {
                        style: {
                            backgroundImage: 'none',
                        },
                    },
                },
                ShareBetslip: {
                    innerContainer: {
                        style: {
                            backgroundImage: 'none',
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.AUTO_CASHOUT_DIALOG]: {
                AC_INPUT: {
                    INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                },
            },
            [PALETTE_IDS.COMBINATION_ODDS_POPUP]: {
                COMBINATION_ODDS_TABLE: {
                    TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                },
            },
            [PALETTE_IDS.LOGIN_DIALOG]: {
                LOGIN_DIALOG_INPUT: {
                    INPUT_TEXT: COLOR.RESERVED.BLACK,
                    INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND3,
                    INPUT_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                },
                LOGIN_DIALOG_ERROR_NOTIFICATION: {
                    ERROR_TEXT: {
                        color: COLOR.RESERVED.BLACK,
                        fontSize: FONT.SIZE_MEDIUM,
                    },
                },
                LOGIN_DIALOG_FORGOT_DETAILS_TEXT: {
                    color: COLOR.BRAND.BACKGROUND6,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                LOGIN_DIALOG_REGISTER_INVITATION_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    color: COLOR.RESERVED.BLACK,
                },
                CHANGE_PASSWORD_CONTAINER_TEXT: {
                    fontSize: FONT.SIZE_XXSMALL,
                    color: COLOR.RESERVED.BLACK,
                },
            },
            [PALETTE_IDS.BET_SHARING_DIALOG]: {
                BET_SHARING_CONTENT_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                BET_SHARING_BET_BASE_INFO: {
                    BET_TOTAL_ODDS_LABEL_TEXT: COLOR.BRAND.FOREGROUND5,
                },
            },
        },
    };
}
